<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Corrective Action Forms'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Created On'"
                            [binding]="'createdOn'"
                            [format]="'g'"
                            [width]="160"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Created By'"
                            [binding]="'createdByUserId'"
                            [dataMap]="createdByMap"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Near Miss'"
                            [binding]="'nearMissDescription'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Injured'"
                            [binding]="'anyoneInjured'"
                            [width]="90"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Correction Made'"
                            [binding]="'correctionMade'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
